import { render, staticRenderFns } from "./EventFormValidationModal.vue?vue&type=template&id=1b82fa6e"
import script from "./EventFormValidationModal.vue?vue&type=script&lang=js"
export * from "./EventFormValidationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports